import { memo, type ReactNode } from 'react';

import { Chip, type ChipProps } from '@air/primitive-chip';
import { cn } from '@air/utils-tailwind';

export type VersionChipProps = {
  children: ReactNode;
  className?: string;
  color?: ChipProps['color'];
  'data-testid'?: string;
};

export const VersionChip = memo(
  ({ children, className, color = 'grey', 'data-testid': dataTestId }: VersionChipProps) => {
    return (
      <Chip
        color={color}
        appearance="filled"
        size="small"
        className={cn(color === 'blue' ? 'ads:bg-primary bg-blue-9 ads:text-inverse text-white' : '', className)}
        data-testid={dataTestId}
      >
        {children}
      </Chip>
    );
  },
);

VersionChip.displayName = 'VersionChip';
